<!--Section: Products v.2-->
<section class="section pb-3">
  <div class="row">
    <div class="col-md-6">
      <blockquote class="blockquote float-left bq-primary">
        <h3 class="bq-title">
          Ultimi Arrivi
        </h3>
      </blockquote>
    </div>
    <div class="col-md-6">
      <a
        class="btn btn-default float-right"
        [routerLink]="['/products/all-products']"
        >Vedi Tutti</a
      >
    </div>
  </div>

  <div *ngIf="loading">
    <app-card-loader [loop]="4" [height]="500"></app-card-loader>
  </div>

  <owl-carousel
    *ngIf="!loading"
    [options]="options"
    [carouselClasses]="['owl-theme', 'row', 'sliding']"
  >
    <!--First column-->
    <div
      class="item"
      style="padding: 20px;"
      *ngFor="let product of bestProducts; let i = index"
    >
      <div class="mb-r">
        <!--Card-->
        <div class="card card-cascade wider">
          <!--Card image-->
          <a [routerLink]="['/products/product', product.product_id]">
            <div class="text-center p-1">
              <img
                [src]="product.thumbnail_picture_url"
                class="img-fluid"
                alt=""
                width="360px"
                height="640px"
              />
              <a>
                <div
                  class="mask waves-effect waves-light"
                  mdbRippleRadius
                ></div>
              </a>
            </div>
          </a>
          <!--/.Card image-->
          <!--Card content-->
          <div class="card-body text-center no-padding">
            <!--Category & Title-->
            <a class="text-muted">
              <h5>{{ product.productCategory }}</h5>
            </a>
            <p class="card-title">
              <strong>
                <a
                  [routerLink]="['/products/product', product.product_id]"
                  routerLinkActive="router-link-active"
                  >{{ product.description | titlecase }}</a
                >
              </strong>
            </p>
            <!--Description-->
            <p>{{ product.product_details["origin"] | titlecase }}</p>
            <!--Card footer-->
            <div class="card-footer">
              <span class="left">Offerta minima: € {{ product.price }}</span>
              <span class="right">
                <a
                  placement="top"
                  mdbTooltip="Aggiungi al carrello"
                  container="body"
                  (click)="addToCart(product)"
                >
                  <i class="fa fa-shopping-basket"></i>
                </a>
              </span>
            </div>
          </div>
          <!--/.Card content-->
        </div>
        <!--/.Card-->
      </div>
      <!--/First column-->
    </div>
  </owl-carousel>
</section>
<!--Section: Products v.2-->
